import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import channel from '../../assets/images/images.png';
import LoginModal from '../Login/LoginModal';
import SearchOverlay from '../SearchOverlay';
import HelpChat from '../HelpChat/HelpChat';
import FdicBanner from './FdicBanner';
import './Header.css';

const MENUS = [
  {
    id: 'checking',
    label: 'Checking & Savings',
    to: '/checking',
    items: [
      { label: 'Checking', to: '/checking' },
      { label: 'Savings', to: '/saving' },
      { label: 'Certificates of Deposit', to: '/cd' },
    ],
  },
  {
    id: 'business',
    label: 'Business',
    to: '/BusinessChecking',
    items: [
      { label: 'Business Checking', to: '/BusinessChecking' },
      { label: 'Business Savings', to: '/Businesssavings' },
      { label: 'Business Loans', to: '/BusinessLoans' },
      { label: 'CDs', to: '/cd' },
    ],
  },
  {
    id: 'loans',
    label: 'Loans',
    to: '/loans',
    items: [
      { label: 'Personal Loans', to: '/loans' },
      { label: 'Business Loans', to: '/BusinessLoans' },
    ],
  },
  {
    id: 'digital',
    label: 'Online & Mobile',
    to: '/OnlineBanking',
    items: [
      { label: 'Online Banking', to: '/OnlineBanking' },
      { label: 'Mobile Banking', to: '/MobileBanking' },
      { label: 'E-Bill Pay', to: '/EBilling' },
      { label: 'Direct Deposit', to: '/DirectDeposit' },
      { label: 'Get the App', to: '/download' },
    ],
  },
  {
    id: 'resources',
    label: 'Resources',
    to: '/about',
    items: [
      { label: 'About Us', to: '/about' },
      { label: 'Locations', to: '/location' },
      { label: 'Customer Portal', href: 'https://portal.gnbank.net' },
      { label: 'Fees Disclosure', to: '/Fees-Disclosure' },
      { label: 'Privacy', to: '/privacy' },
      { label: 'Terms', to: '/terms' },
    ],
  },
];

const Header = () => {
  const [showModal, setShowModal] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);

  return (
    <div className="desktop gn-header-wrap">
      <header className="gn-header">
        <FdicBanner />
        <div className="gn-header__top">
          <div className="gn-container gn-header__top-inner">
            <Link to="/" className="gn-header__logo" aria-label="GN Bank home">
              <img src={channel} alt="GN Bank" />
              <span className="gn-header__logo-text">GN Bank</span>
            </Link>

            <nav className="gn-header__utility" aria-label="Top Menu">
              <Link to="/about" className="gn-header__utility-link">
                About Us
              </Link>
              <Link to="/contact" className="gn-header__utility-link">
                Contact Us
              </Link>
              <HelpChat label="Help" />
              <SearchOverlay label="Search" />
              <button
                type="button"
                className="btn btn-gn-primary gn-header__login"
                onClick={() => setShowModal(true)}
              >
                Log in
              </button>
            </nav>
          </div>
        </div>

        <div className="gn-header__main">
          <div className="gn-container">
            <nav className="gn-header__products" aria-label="Product Menu">
              {MENUS.map((menu) => (
                <div
                  key={menu.id}
                  className={`gn-header__product${openMenu === menu.id ? ' is-open' : ''}`}
                  onMouseEnter={() => setOpenMenu(menu.id)}
                  onMouseLeave={() => setOpenMenu(null)}
                >
                  <NavLink
                    to={menu.to}
                    className="gn-header__product-btn"
                    aria-expanded={openMenu === menu.id}
                    aria-haspopup="true"
                    onFocus={() => setOpenMenu(menu.id)}
                  >
                    {menu.label}
                  </NavLink>
                  <div className="gn-header__dropdown" role="menu">
                    {menu.items.map((item) =>
                      item.href ? (
                        <a
                          key={item.label}
                          className="gn-header__dropdown-link"
                          href={item.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          role="menuitem"
                        >
                          {item.label}
                        </a>
                      ) : (
                        <Link
                          key={item.label}
                          className="gn-header__dropdown-link"
                          to={item.to}
                          role="menuitem"
                          onClick={() => setOpenMenu(null)}
                        >
                          {item.label}
                        </Link>
                      )
                    )}
                  </div>
                </div>
              ))}
              <NavLink to="/location" className="gn-header__product-btn gn-header__product-btn--link">
                Locations
              </NavLink>
            </nav>
          </div>
        </div>
      </header>

      <LoginModal show={showModal} handleClose={() => setShowModal(false)} />
      <div className="spacer" />
    </div>
  );
};

export default Header;
